export default __webpack_public_path__ + "images/IHO.93fb15a.png";